import * as React from 'react';
import Clipboard from 'common/components/Clipboard';
import Name from 'common/components/Name';
import Item from 'common/app/Business/EncryptItem';
import { CopyOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import * as intl from "react-intl-universal";
import { NavLink as Link } from 'react-router-dom';

interface iProps {
    display?: any;
    link?: string; // 内部组件路由跳转
    href?: string; // 外部链接跳转
    copy?: boolean;
    adaptFn?: Function;
    clipboard?: any;
    wrap?: boolean;
    nameConfig?: any;
    showName?: boolean;
    showDecrypt?: boolean; // 显示解密按钮
    decryptConfig?: any; // 解密所需配置
    target?: string;
    phoneCountryKey?: string; // 国家key
}

@Clipboard()
export default class StaticView extends React.Component<iProps> {
    /**
     * 获取悬停提示内容
     * @param ctx
     * @returns {string}
     */
    getTipTitle = (ctx: any): string => {
        return ({
            'string': ctx,
            'object': ctx && ctx.props && typeof ctx.props.children === 'string' ? ctx.props.children : ''
        }as any)[typeof ctx] || '';
    };

    /**
     * 模糊文案
     */
    blurText = (value: string) => {
        const { origin, config } = this.props.decryptConfig;
        const configObj: any = {
            clue: '/v2/sales/clue/decrypt',
            audit: '/v2/audit/user/decrypt',
            crm: '/v2/client/crm/decrypt',
            sales: '/v2/sales/account/decrypt',
            admin: '/v2/user/admin/decrypt',
        };
        return <Item action={configObj[origin]} value={value} config={config} phoneCountryKey={this.props.phoneCountryKey} />;
    };

    render() {
        const { display, adaptFn, copy, clipboard, link, href, target, wrap, nameConfig, showName = false, showDecrypt = false } = this.props;
        let ctx = adaptFn ? (adaptFn(display) || '-') : display;
        let hasRouter = !!ctx && ctx !== '-' && (link || href);
        return (
            <span className={`StaticView ${wrap ? 'auto-break' : 'ellipsis'}`}
                  style={{ color: '#95969b', marginRight: 10 }} title={this.getTipTitle(ctx)}>
                { hasRouter
                    ? [
                        !!link && <Link key='link' to={link}>{ctx}</Link>,
                        !!href && <a key='url' href={href} target={target?target:'_blank'}>{ctx}</a>
                    ]
                    : showName && ctx && ctx !== '-' && nameConfig && nameConfig.type
                        ? <Name id={nameConfig && nameConfig.uuid} roleMap={nameConfig && nameConfig.roleMap}
                                type={nameConfig && nameConfig.type}><a style={{ cursor: "pointer" }}>{ctx}</a>
                            </Name>
                        : showDecrypt && ctx && ctx !== '-' && ctx !== '(-) -'
                            ? this.blurText(ctx)
                            : ctx
                }
                {copy && <Tooltip placement='topLeft' title={intl.get('Global.Copy')}>
                    <a onClick={() => clipboard.copy(ctx)}> <CopyOutlined /></a>
                </Tooltip>}
            </span>
        );
    }
}
